import { render } from "./ProjectsListComponent.vue?vue&type=template&id=9c4eb914&scoped=true"
import script from "./ProjectsListComponent.vue?vue&type=script&lang=js"
export * from "./ProjectsListComponent.vue?vue&type=script&lang=js"

import "./ProjectsListComponent.vue?vue&type=style&index=0&id=9c4eb914&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c4eb914"]])

export default __exports__